import { render, staticRenderFns } from "./ExtensionSelector.vue?vue&type=template&id=02da6810&"
import script from "./ExtensionSelector.vue?vue&type=script&lang=js&"
export * from "./ExtensionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports